module.exports = __webpack_public_path__ + "img/2.bcc08849.png";